import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "react-toastify";
import "styles/admin.css";
import SubjectViewModal from "components/modal/SubjectViewModal";

const AdminSubjectList = ({ subjects, fetchSubjects, onEdit, onView }) => {
  const [hoveredDropdown, setHoveredDropdown] = useState(null);
  const [assignModal, setAssignModal] = useState({
    open: false,
    subject: null,
  });
  const [viewModal, setViewModal] = useState({
    open: false,
    subject: null,
    details: null,
  });
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingDetails, setLoadingDetails] = useState(false);

  const API_BASE = "https://algoritm-api-edu.uz";
  const ADMIN_API = "https://algoritm-api-edu.uz/api/admin";

  const fetchSubjectDetails = async (slug) => {
    setLoadingDetails(true);
    const token = localStorage.getItem("accessToken");

    try {
      const res = await fetch(`${ADMIN_API}/Subjects/GetBySlug/${slug}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) {
        const err = await res.text();
        throw new Error(err || "Fan ma'lumotlarini olishda xato");
      }

      const data = await res.json();
      setViewModal((prev) => ({ ...prev, details: data }));
      console.log(data);
      
    } catch (err) {
      console.error(err);
      toast.error("Fan batafsil ma'lumotlarini yuklashda xato: " + err.message);
    } finally {
      setLoadingDetails(false);
    }
  };
  const handleView = (subject) => {
    setViewModal({ open: true, subject, details: null });
    fetchSubjectDetails(subject.slug);
  };

  const handleAssignClick = async (subject) => {
    if (subject.status !== "Confirmed") {
      return toast.warn(
        "Faqat tasdiqlangan fanlarga o‘qituvchi biriktirish mumkin!"
      );
    }

    setAssignModal({ open: true, subject });
    setSelectedUserId("");
    setLoadingUsers(true);

    const token = localStorage.getItem("accessToken");

    try {
      const res = await fetch(`${ADMIN_API}/Users/GetAll`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search: "",
          sortBy: "",
          orderType: "asc",
          pageSize: 200,
          page: 1,
        }),
      });

      if (!res.ok) {
        const errorText = await res.text();
        toast.error("Foydalanuvchilarni yuklashda xato: " + res.status);
        console.error("API xatosi:", errorText);
        setUsers([]);
        return;
      }

      const data = await res.json();

      let userList = [];
      if (Array.isArray(data)) {
        userList = data;
      } else if (data && typeof data === "object") {
        userList = data.rows || data.data || data.items || data.result || [];
      }

      const teachers = userList.filter(
        (user) => user.role && user.role.toLowerCase().includes("teacher")
      );

      setUsers(teachers);

      if (teachers.length === 0) {
        toast.warn("Sistemada o‘qituvchi topilmadi.");
      }
    } catch (err) {
      console.error("Fetch xatosi:", err);
      toast.error("Internet aloqasi bilan muammo yuz berdi!");
      setUsers([]);
    } finally {
      setLoadingUsers(false);
    }
  };

  const handleAssignUser = async () => {
    if (!selectedUserId) {
      return toast.error("Iltimos, o‘qituvchi tanlang!");
    }

    const token = localStorage.getItem("accessToken");
    const selectedUser = users.find((u) => u.id === selectedUserId);

    try {
      const res = await fetch(`${ADMIN_API}/Subjects/assign-user`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          subjectSlug: assignModal.subject.slug,
          userId: selectedUserId,
        }),
      });

      if (res.ok) {
        toast.success(
          `${assignModal.subject.fullName} fani → ${selectedUser.username} ga muvaffaqiyatli biriktirildi!`
        );
        setAssignModal({ open: false, subject: null });
        setSelectedUserId("");
        setUsers([]);
        fetchSubjects();
      } else {
        const errText = await res.text();
        toast.error("Biriktirishda xato: " + errText);
      }
    } catch (err) {
      console.error(err);
      toast.error("Server bilan aloqa uzildi.");
    }
  };

  const handleDelete = async (subject) => {
    if (subject.status === "Confirmed") {
      return toast.error("Tasdiqlangan fan o‘chirilmaydi!");
    }
    if (!window.confirm("Haqiqatan ham ushbu fanni o‘chirmoqchimisiz?")) return;

    const token = localStorage.getItem("accessToken");
    const res = await fetch(`${ADMIN_API}/Subjects/Delete/${subject.slug}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.ok) {
      toast.success("Fan muvaffaqiyatli o‘chirildi!");
      fetchSubjects();
    } else {
      toast.error("O‘chirishda xato yuz berdi.");
    }
  };

  const handleConfirm = async (subject) => {
    if (!window.confirm("Fan tasdiqlansinmi?")) return;
    const token = localStorage.getItem("accessToken");
    const res = await fetch(`${ADMIN_API}/Subjects/Confirm/${subject.slug}`, {
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
    });
    if (res.ok) {
      toast.success("Fan tasdiqlandi!");
      fetchSubjects();
    } else {
      toast.error("Tasdiqlashda xato");
    }
  };

  const handleCancel = async (subject) => {
    if (!window.confirm("Fan tasdiqi bekor qilinsinmi?")) return;
    const token = localStorage.getItem("accessToken");
    const res = await fetch(`${ADMIN_API}/Subjects/Cancel/${subject.slug}`, {
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
    });
    if (res.ok) {
      toast.success("Tasdiq bekor qilindi!");
      fetchSubjects();
    } else {
      toast.error("Bekor qilishda xato");
    }
  };

  return (
    <>
      <div className="subject-list">
        <AnimatePresence>
          {subjects.length === 0 ? (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              style={{
                textAlign: "center",
                padding: "100px 20px",
                color: "#94a3b8",
              }}
            >
              <h3>Hozircha fanlar yo‘q</h3>
            </motion.div>
          ) : (
            subjects.map((s, index) => (
              <motion.div
                key={s.slug}
                layout
                initial={{ opacity: 0, y: 40, scale: 0.92 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{
                  delay: index * 0.06,
                  type: "spring",
                  stiffness: 280,
                }}
                className="subject-card"
                whileHover={{ y: -6, transition: { duration: 0.2 } }}
              >
                <div className="status-indicator">
                  <span
                    className={`status-circle ${
                      s.status === "Created"
                        ? "new"
                        : s.status === "Confirmed"
                        ? "confirmed"
                        : s.status === "Modified"
                        ? "modified"
                        : "cancelled"
                    }`}
                  />
                </div>

                {s.imgUrl ? (
                  <img
                    src={`${API_BASE}/${s.imgUrl}`}
                    alt={s.fullName}
                    className="subject-image"
                    onError={(e) =>
                      (e.target.src =
                        "https://via.placeholder.com/300x200/6366f1/ffffff?text=Fan")
                    }
                    style={{
                      objectFit: "cover",
                      width: "100%",
                      height: "180px",
                      borderRadius: "12px",
                    }}
                  />
                ) : (
                  <div className="subject-placeholder">
                    <span>Rasm yo‘q</span>
                  </div>
                )}

                <div className="subject-info">
                  <h4>{s.fullName}</h4>
                  <p>{s.shortName}</p>
                </div>

                <div
                  className="dropdown-wrapper"
                  style={{ position: "absolute", top: "8px", right: "8px" }}
                  onMouseEnter={() => setHoveredDropdown(s.slug)}
                  onMouseLeave={() => setHoveredDropdown(null)}
                >
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "22px",
                      fontWeight: "bold",
                    }}
                  >
                    ⋮
                  </span>

                  <AnimatePresence>
                    {hoveredDropdown === s.slug && (
                      <motion.div
                        initial={{ opacity: 0, scale: 0.85, y: -10 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.85 }}
                        transition={{ duration: 0.18 }}
                        className="dropdown-menu"
                        style={{
                          position: "absolute",
                          top: "34px",
                          right: "0",
                          background: "white",
                          border: "1px solid #e2e8f0",
                          borderRadius: "12px",
                          minWidth: "170px",
                          boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                          zIndex: 100,
                          overflow: "hidden",
                        }}
                      >
                        <p onClick={() => handleView(s)}>Ko‘rish</p>

                        {s.status === "Confirmed" && (
                          <p onClick={() => handleAssignClick(s)}>
                            Biriktirish
                          </p>
                        )}

                        {(s.status === "Created" ||
                          s.status === "Modified" ||
                          s.status === "Cancelled") && (
                          <>
                            <p onClick={() => handleConfirm(s)}>Tasdiqlash</p>
                            <p onClick={() => onEdit(s)}>Tahrirlash</p>
                            <p onClick={() => handleDelete(s)}>O‘chirish</p>
                          </>
                        )}

                        {s.status === "Confirmed" && (
                          <p onClick={() => handleCancel(s)}>Bekor qilish</p>
                        )}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </motion.div>
            ))
          )}
        </AnimatePresence>
      </div>

      <AnimatePresence>
        {assignModal.open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="modal-backdrop"
            onClick={() => setAssignModal({ open: false, subject: null })}
          >
            <motion.div
              initial={{ scale: 0.85, y: 60 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.85, y: 60 }}
              transition={{ type: "spring", stiffness: 300 }}
              className="modal-content"
              onClick={(e) => e.stopPropagation()}
              style={{
                maxWidth: "440px",
                borderRadius: "16px",
                padding: "24px",
              }}
            >
              <h3
                style={{
                  margin: "0 0 20px",
                  fontSize: "19px",
                  fontWeight: "600",
                }}
              >
                "{assignModal.subject?.fullName}" faniga o‘qituvchi biriktirish
              </h3>

              {loadingUsers ? (
                <div style={{ textAlign: "center", padding: "20px" }}>
                  <p>Yuklanmoqda...</p>
                </div>
              ) : users.length === 0 ? (
                <p style={{ color: "#94a3b8", textAlign: "center" }}>
                  O‘qituvchi topilmadi
                </p>
              ) : (
                <select
                  value={selectedUserId}
                  onChange={(e) => setSelectedUserId(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "14px 16px",
                    borderRadius: "12px",
                    border: "2px solid #e2e8f0",
                    fontSize: "16px",
                    backgroundColor: "white",
                  }}
                >
                  <option value="">O‘qituvchi tanlang</option>
                  {users.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.fullName || user.firstName + " " + user.lastName} (
                      {user.role})
                    </option>
                  ))}
                </select>
              )}

              <div
                className="modal-buttons"
                style={{ gap: "12px", marginTop: "24px" }}
              >
                <button
                  className="btn-save"
                  onClick={handleAssignUser}
                  disabled={loadingUsers || !selectedUserId}
                >
                  Biriktirish
                </button>
                <button
                  className="btn-cancel"
                  onClick={() => setAssignModal({ open: false, subject: null })}
                >
                  Bekor qilish
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      <SubjectViewModal
        isOpen={viewModal.open}
        onClose={() =>
          setViewModal({ open: false, subject: null, details: null })
        }
        subject={viewModal.subject}
        details={viewModal.details}
        loading={loadingDetails}
      />
    </>
  );
};

export default AdminSubjectList;
